import {portalRedirect} from '@/router/portalRedirect'

// Keep legacy names for payment/auth callbacks. Their hrefs belong to portal.
const compatibility = [
    ['dashboard', 'dashboard', 'portalHome'], ['factors', 'wallet', 'portalPayments'],
    ['packages', 'packages', 'portalPackage'], ['myoutcome', 'myoutcome', 'portalProgress'],
    ['sessions/request', 'sessions-request', 'portalNextSessionBooking'],
    ['my-sessions', 'sessions', 'portalSessions'], ['overview', 'panelLayout', 'portalHome'],
]

export default [
    ...compatibility.map(([path, name, target]) => ({path, name, redirect: portalRedirect(target)})),
    {
        path: 'services', name: 'portalServices',
        component: () => import('../../views/portal/PortalServicesStep.vue'),
        meta: {auth: true, nav: 'services', titleKey: 'intake.portal.navServices'},
    },
    {
        path: '',
        component: () => import('../../views/portal/PortalFeatureView.vue'),
        meta: {auth: true},
        children: [
            {
                path: 'profile', name: 'setting',
                component: () => import('../../views/panel/NewProfile.vue'),
                meta: {auth: true, nav: 'services', titleKey: 'routes.personal_profile'},
            },
            {
                path: 'profile/complete', name: 'userOnboarding',
                component: () => import('../../views/panel/UserOnboarding.vue'),
                meta: {auth: true, nav: 'services', titleKey: 'routes.userInfo', featureBack: 'setting'},
            },
            {
                path: 'tests', name: 'tests',
                component: () => import('../../components/Dashboard/Layouts/TestUserDashboard.vue'),
                meta: {auth: true, nav: 'services', titleKey: 'routes.tests'},
            },
            {
                path: 'tests/:testID/history', name: 'test_history',
                component: () => import('../../views/panel/TestsHistoryView.vue'),
                meta: {auth: true, nav: 'services', titleKey: 'routes.test_history', featureBack: 'tests'},
            },
            {
                path: 'tasks', name: 'tasks',
                component: () => import('../../views/panel/TasksView.vue'),
                meta: {auth: true, nav: 'services', titleKey: 'routes.tasks'},
            },
            {
                path: 'payments/checkout', name: 'basket',
                component: () => import('../../views/panel/BasketView.vue'),
                meta: {auth: true, nav: 'payments', titleKey: 'routes.basket', featureBack: 'portalPayments'},
            },
            {
                path: 'payments/invoices/:factorID', name: 'factor',
                component: () => import('../../views/panel/SingleFactorView.vue'),
                meta: {auth: true, nav: 'payments', titleKey: 'routes.factor', featureBack: 'portalPayments'},
            },
            {
                path: 'invitees', name: 'invitees',
                component: () => import('../../views/panel/Invitess.vue'),
                meta: {auth: true, nav: 'services', titleKey: 'routes.invitees'},
            },
            {
                path: 'roots-in-soil', name: 'roots-in-soil',
                component: () => import('../../views/indexes/rootsInSoil.vue'),
                meta: {auth: true, nav: 'services', titleKey: 'routes.roots_in_soil'},
            },
            {
                path: 'mental-ai-tool', name: 'chatGpt',
                component: () => import('../../views/panel/MentalAiTool.vue'),
                meta: {auth: true, nav: 'services', titleKey: 'routes.chatGpt'},
            },
            {
                path: 'events/:id', name: 'eventDetail',
                component: () => import('../../views/panel/Event/EventDetail.vue'),
                meta: {auth: true, nav: 'services', titleKey: 'routes.presession_detail'},
            },
        ],
    },
]
